<template lang="pug">
.v-field-select.field-select
	button.field-select__btn(type="button"
		@click="openSelect"
		:id="uniqueId"
		:disabled="field.disabled")
		span.field-select__btn-text(v-if="localValue && localValue.length" key="text") {{ field.value.text }}
		span.field-select__btn-placeholder(v-else="" key="placeholder") {{field.placeholder}}
		v-svg-icon.field-select__btn-arrow(:icon="'chevron-down-sm'")

</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';
import controller from '../scripts/controller/controller.js';

export default {
	props: {
		radio: {
			type: Boolean,
			default: false
		},

		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value',
	],

	data() {
		return {
			localValue: null,
			uniqueId: uniqueId('field-'),
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		},
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		openSelect() {
			controller.openModal({
				className: 'modal--select modal-regions',
				component: {
					name: 'v-modal-select',
					props: {
						dataSource: this.field,
						modelValue: this.localValue,
					},
					listeners: {
						'change-select': async (data) => {
							this.localValue = data;
						},

						'update:model-value': async (data) => {
							this.$emit('update:model-value', data);
						}
					}
				}
			});
		},

	},

};
</script>